import styled from "styled-components"

export default function ProductVendorInfo({ vendorInfo }) {
  return (
    <VendorInfoSection>
      <ContentSection>
        <SectionTitle>판매자 정보</SectionTitle>
        <TableForm>
          <TableRow>
            <TableHeader>판매자명</TableHeader>
            <TableContent>{vendorInfo.company_name}</TableContent>
          </TableRow>
          <TableRow>
            <TableHeader>상호/대표자</TableHeader>
            <TableContent>{vendorInfo.ceo_name}</TableContent>
          </TableRow>

          <TableRow>
            <TableHeader>연락처</TableHeader>
            <TableContent>{vendorInfo.phone}</TableContent>
          </TableRow>

          <TableRow>
            <TableHeader>이메일</TableHeader>
            <TableContent>{vendorInfo.email}</TableContent>
          </TableRow>

          <TableRow>
            <TableHeader>주소</TableHeader>
            <TableContent>{vendorInfo.address}</TableContent>
          </TableRow>

          <TableRow>
            <TableHeader>통신판매업 신고 번호</TableHeader>
            <TableContent>{vendorInfo.sales_report_number}</TableContent>
          </TableRow>

          <TableRow>
            <TableHeader>사업자 번호</TableHeader>
            <TableContent>{vendorInfo.business_registration_number}</TableContent>
          </TableRow>
        </TableForm>
      </ContentSection>
    </VendorInfoSection>
  )
}

const VendorInfoSection = styled.div`
  padding-left: calc(100vw * (17 / 375));
  padding-right: calc(100vw * (17 / 375));
  padding-top: calc(100vw * (29 / 375));
  overflow-y: scroll;
`

const ContentSection = styled.div`
  border-bottom: 1px solid #efefef;
  padding-bottom: calc(100vw * (22 / 375));
  margin-bottom: calc(100vw * (22 / 375));

  &:last-child {
    border-bottom: none;
  }
`

const SectionTitle = styled.h3`
  font-weight: 600;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #121212;
  margin-bottom: calc(100vw * (22 / 375));
`

const TableForm = styled.div``

const TableRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: calc(100vw * (12 / 375));
`

const TableHeader = styled.span`
  width: calc(100vw * (100 / 375));
  min-width: calc(100vw * (81 / 375));
  margin-right: calc(100vw * (12 / 375));
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #4e4e4e;
`

const TableContent = styled.span`
  font-weight: 400;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (18 / 375));
  color: #7f7f7f;
  white-space: pre-line;
`
